import actions from "./actions";

const initState = {
  isLoading: false,
  errorMessage: false,
  featuresSelector: {},
  features: [],
  featuresByProperties: [],
  modalActive: false,
  feature: {
    id: null,
    name: "",
    enabled: "true", // publish
    description: "",
    created_at: new Date().getTime(),
    deleted_at: null, // soft delete
  },
};

export default function reducer(state = initState, { type, payload }) {
  switch (type) {
    case actions.LOAD_FROM_FIRESTORE:
      return {
        ...state,
        isLoading: true,
        errorMessage: false,
        modalActive: false,
      };
    case actions.LOAD_FROM_FIRESTORE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        features: payload.data,
        featuresSelector: payload.data,
        errorMessage: false,
      };
    case actions.LOAD_FROM_FIRESTORE_ERROR:
      return {
        ...state,
        isLoading: false,
        errorMessage: "There is a loading problem",
      };
    case actions.LOAD_FEATURES_SELECTOR_SUCCESS:
      return {
        ...state,
        isLoading: false,
        featuresSelector: payload.data,
      };
    case actions.LOAD_FEATURES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        featuresSelector: payload.data,
        features: payload.data,
      };
    case actions.LOAD_BY_PROPERTY_FROM_FIRESTORE:
      return {
        ...state,
        isLoading: true,
        errorMessage: false,
      };
    case actions.LOAD_BY_PROPERTY_FROM_FIRESTORE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        featuresByProperties: payload.data,
        errorMessage: false,
      };
    case actions.LOAD_BY_PROPERTY_FROM_FIRESTORE_ERROR:
      return {
        ...state,
        isLoading: false,
        errorMessage: "There is a loading problem",
      };
    case actions.TOGGLE_FIRESTORE_HANDLE_MODAL:
      return {
        ...state,
        modalActive: !state.modalActive,
        feature:
          payload.data == null
            ? {
                id: null,
                name: "",
                enabled: "true", // publish
                description: "",
                created_at: new Date().getTime(),
                deleted_at: null, // soft delete
              }
            : payload.data,
      };
    case actions.FIRESTORE_UPDATE:
      return {
        ...state,
        feature: payload.data,
      };
    default:
      return state;
  }
}
